<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <form class="form-horizontal" @submit.prevent="onSubmit">
          <card class="text-left">
            <template slot="header">
              <h4 class="card-title">FAQ 등록</h4>
            </template>
            <div>
              <div class="row">
                <label class="col-sm-2 col-form-label">카테고리</label>
                <div class="col-sm-10">
                  <el-select class="select-primary" size="large" placeholder="카테고리선택" v-model="categoryId">
                    <el-option
                      v-for="option in categories"
                      class="select-primary"
                      :value="option.id"
                      :label="option.category"
                      :key="option.category"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">아이디</label>
                <div class="col-sm-10">
                  <base-input placeholder="아이디" v-model="id" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">말머리</label>
                <div class="col-sm-10">
                  <base-input placeholder="말머리" v-model="subject" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">타이틀</label>
                <div class="col-sm-10">
                  <base-input placeholder="타이틀" v-model="title" required>
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>

              <div class="row">
                <label class="col-sm-2 col-form-label">내용</label>
                <div class="col-sm-10">
                  <base-input placeholder="내용">
                    <textarea class="form-control" id="content" rows="30" v-model="content" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">노출여부</label>
                <div class="col-sm-10">
                  <base-switch v-model="isVisible" type="primary" on-text="ON" off-text="OFF" />
                </div>
              </div>
            </div>
          </card>
          <base-button native-type="submit" type="success">등록</base-button>
          <base-button v-if="faqId" @click="deleteFaq" type="danger">삭제</base-button>
          <base-button @click="goBack" type="default">뒤로</base-button>
        </form>
        <!-- end card -->
      </div>
    </div>
  </div>
</template>
<script>
import { Card, BaseInput, BaseButton, BaseSwitch } from "@/components/index";
import { Toast } from "@/util/Toast";
import swal from "sweetalert2";
import { showAPIErrorToast } from "../../util/ErrorUtils";

export default {
  components: {
    Card,
    BaseButton,
    BaseInput,
    BaseSwitch,
  },
  async created() {
    await this.getCategories();
    if (this.$route.query.id) {
      this.faqId = this.$route.query.id;
      await this.getFaq();
    }
  },
  data() {
    return {
      faqId: null,
      id: null,
      subject: null,
      title: null,
      content: null,
      isVisible: true,
      categoryId: null,
      categories: [],
    };
  },

  methods: {
    async getCategories() {
      return this.$axios.get(`/faq/categories`, null).then((res) => {
        this.categories = res.data.data;
      });
    },
    async getFaq() {
      return this.$axios.get(`/faq/${this.faqId}`, null).then((res) => {
        const data = res.data.data;
        this.id = data.faqId;
        this.subject = data.subject;
        this.title = data.title;
        this.content = data.content;
        this.categoryId = data.categoryId;
        this.isVisible = data.isVisible === 1;
      });
    },

    async onSubmit() {
      if (this.title === null) {
        Toast.error("제목을 입력해주세요");
        return;
      }
      if (this.content === null) {
        Toast.error("내용을 입력해주세요");
        return;
      }
      if (this.subject === null) {
        Toast.error("말머리를 입력해주세요");
        return;
      }
      const param = {};
      param.id = Number(this.id);
      param.subject = this.subject;
      param.title = this.title;
      param.content = this.content;
      param.categoryId = this.categoryId;
      param.isVisible = this.isVisible ? 1 : 0;
      try {
        if (this.faqId) {
          param.faqId = this.faqId;
          await this.$axios.put(`/faq/${this.faqId}`, param).then((res) => {
            Toast.success("수정되었습니다");
            history.go(-1);
          });
        } else {
          await this.$axios.post(`/faq`, param).then((res) => {
            Toast.success("등록되었습니다");
            history.go(-1);
          });
        }
      } catch (err) {
        console.log(err);
        showAPIErrorToast(err);
      }
    },

    async deleteFaq() {
      swal
        .fire({
          title: "삭제 확인",
          text: `${this.faqId} FAQ를 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const param = {};
              if (this.faqId) {
                param.faqId = this.faqId;

                return this.$axios.delete(`/faq/${this.faqId}`, param).then((res) => {
                  Toast.success("삭제되었습니다");
                  history.go(-1);
                });
              }
            } catch (err) {
              Toast.error("FAQ 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped>
textarea#content {
  max-height: 300px;
}
.bootstrap-switch {
  margin: 6px;
}
</style>
